import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {SelectorComponent} from './selector.component';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [SelectorComponent],
    exports: [SelectorComponent],
})
export class SelectorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/selector/selector.module.ts